export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_01.c7e07622.jpg";